seedWebApp.controller('IssuesController', ['$scope', '$uibModal', 'HelpdeskService', 'ToastService',
    function ($scope, $uibModal, HelpdeskService, ToastService) {

        $scope.prefs = {
            name: 'IssuesGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
            parentFilter: "OPEN",
            canSelect: true,
        };

        $scope.statusFilter = 'OPEN';

        $scope.loadService = HelpdeskService.getIssues;
        $scope.loadColumns = HelpdeskService.getIssuesColumns;
        $scope.resetService = HelpdeskService.resetCache;

        //$scope.stages = HelpdeskService.getStages();

        //console.log('issues');
        HelpdeskService.getStagesByID().then(
            function (response) {
                //console.log('resp', response);
                //console.log(response.data);
                $scope.stages = response;
            }
        );


        //$scope.getTotal = function () {
        //    $scope.loadingTotal = true;
        //    HelpdeskService.getIssuesCount().then(function (response) {
        //        $scope.loadingTotal = false;
        //        $scope.totalItems = response.data;
        //    });
        //};

        //$scope.getTotal();

        $scope.statusClass = function (item) {
            return 'status-issue';
        };

        $scope.statusStyle = function (item) {
            if (!$scope.stages) {
                return;
            }
            var stage = $scope.stages[item];
            if (stage) {
                return 'color: ' + stage.ForeColor + ';background-color: ' + stage.BackColor + '; padding:1.5px 5px 1.5px 5px; border-radius:4px; ';
            }
            else {
                return '';
            }
        };

        $scope.IssueTypeClass = function (item) {
            return 'issue-type ' + item;
        };        

        $scope.qtPOClass = function (item) {
            return 'qt-pos';
        };

        //$scope.materialTypeClass = function (item) {
        //    if (item == 'CADASTRAR') {
        //        return 'material-type-to-insert';
        //    }
        //};

        $scope.getCustomText = function (item) {
            if (!$scope.stages) {
                return;
            }
            if ($scope.stages[item]) {
                return $scope.stages[item].StageName;
            }
            else {
                return item;
            }
        };

        $scope.showApproval = function (approval, item) {
            return true;
            //return HelpdeskService.isApprovalRequired(item.CreditNoteClaim, approval);
        };

        
        $scope.setColumns = function () {
            var hideClosed = $scope.prefs.parentFilter == 'OPEN';
            $scope.columns = [
                { name: 'CreateUserID', display: 'Cre', filterOptions: [], width: 1, dataType: 'avatar' },
                //{ name: 'UpdateUserID', display: 'Upd', filterOptions: [], width: 1, dataType: 'avatar' },           
                { name: 'BratID', display: 'BratID', filterOptions: [], width: 10 },
                { name: 'IssueSubject', display: $scope.translation.Subject, filterOptions: [], width: 15 },
                { name: 'StatusID', display: 'Status', filterOptions: [], limitTo: '35', width: 5, id: 'StatusID', customStyle: $scope.statusStyle, customClass: $scope.statusClass, dataType: 'customText', getCustomText: $scope.getCustomText },
                { name: 'IsClosed', display: $scope.translation.Closed, filterOptions: [], width: 1, dataType: 'boolean', hide: hideClosed },                                   
                { name: 'AssignedUserIDs', display: 'Assigned', filterOptions: [], width: 1, dataType: 'avatars' },
                //{ name: 'AssignedApprovalUserID', display: 'Next Approval', filterOptions: [], width: 1, dataType: 'avatar' },
                { name: 'ApprovalUsers', display: 'Approvals', width: 5, dataType: 'approvals', showApproval: $scope.showApproval },
                { name: 'ContactName', display: $scope.translation.Client, id: 'ContactID', filterOptions: [], width: 5 },
                { name: 'OrderID', display: 'Order', width: 5, filterOptions: [] },
                { name: 'ContractNumber', display: 'PO', width: 5, filterOptions: [] },
                { name: 'IssueType', display: $scope.translation.Type, filterOptions: [], limitTo: '10', width: 5, customClass: $scope.IssueTypeClass }, //, translationPrefix: 'Issue_'
                { name: 'IssueDate', display: $scope.translation.Date, dataType: 'date', format: $scope.translation.DatePickerFormat, filterOptions: [], width: 5 },
                { name: 'UpdateDate', display: $scope.translation.Update, dataType: 'date', format: $scope.translation.DatePickerFormat, filterOptions: [], width: 5 },
                { name: 'IssueID', display: 'IssueID', customClass: function () { return 'agp-color'; }, filterOptions: [], width: 5, isKey: true },
            ];
        }
        $scope.setColumns();

        $scope.insertNew = function () {
            //DicService.openDicModal();
        }

        $scope.prefs.customEdit = function (item) {
            $scope.editItem(item);
        };

        $scope.editItem = function (item) {
            //$scope.$broadcast('addItem');
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/helpdesk/issueModal.html' + seedWebApp.buildVersion,
                controller: 'IssueModalController',
                size: 'xl',
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            });
            modalInstance.result.then(function (status) {
                $scope.doRefresh();
            });

        };

        $scope.doInsert = function () {
            $scope.editItem(null);
        };
        
        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'chamados');
        };

        $scope.setFilter = function (status) {
            console.log('setFilter ' + status);
            $scope.setColumns();            
            $scope.$broadcast('onParentFilterChanged', $scope.filterString);
            $scope.doRefresh();
        };

        $scope.clearSelected = function () {           
            //console.log('clearSelected');
            $scope.$broadcast('clearSelected');
        };

        $scope.isAgent = function () {
            if (!$scope.loggedUser) {
                return false;
            }
            return $scope.loggedUser.UserType == 'AGENT';
        };

        $scope.changeSelected = function () {

            console.log('changeSelected');
            if (!$scope.isAgent()) {
                return;
            }

            var sel = [];
            $scope.prefs.items.forEach(function (item) {
                if (item.selected) {
                    sel.push(item);
                }
            })

            var modalInstance = $uibModal.open({
                templateUrl: './SPA/helpdesk/changeIssuesModal.html' + seedWebApp.buildVersion,
                controller: 'ChangeIssuesModalController',
                size: 'lg',
                resolve: {
                    items: function () {
                        return sel;
                    }
                }
            });
            modalInstance.result.then(function (status) {
                $scope.clearSelected();
                $scope.doRefresh();
            });
        };

        $scope.copySelected = function () {
            //console.log('copySelected');
            //console.log($scope.prefs.items);            
            $scope.copyItems($scope.prefs.items);            
        };

        $scope.copyItems = function (items) {
            var clipText = '';
            if (!items) {
                return;
            }
            //var details = order.Details;
            var clipCount = 0;
            for (var i = 0; i < items.length; i++) {                
                var item = items[i];
                if (item.selected) {
                    clipCount++;
                    clipText += item.IssueID + ': ';
                    //clipText += String.fromCharCode(9); //Tab
                    clipText += item.IssueSubject;
                    clipText += String.fromCharCode(9); //Tab
                    clipText += '[' + $scope.translation['Status_' + item.StatusID] + ']';
                    clipText += String.fromCharCode(9); //Tab
                    clipText += String.fromCharCode(13); //LF
                }                
            }
            if ($scope.copyToClipboard(clipText)) {
                ToastService.createToast(clipCount + ' iten(s) copiado(s) para rascunho', '', 4000, 'success');
            }
            else {
                ToastService.createToast('Erro ao copiar para rascunho', '', 4000, 'error');
            }
        };


        //JRM: PASSAR PARA SERVICE
        $scope.copyToClipboard = function (text) {
            if (window.clipboardData && window.clipboardData.setData) {
                return clipboardData.setData("Text", text);
            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement("textarea");
                textarea.textContent = text;
                textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        };

    }
]);
